module.exports = __webpack_public_path__ + "img/image_6.e7cc92e6.png";